var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showHighScores)?_c('HighScoresScreen'):(! _vm.isGameActive)?_c('MainMenu'):_vm._e(),(_vm.isGameInitialized && _vm.isGameActive && ! _vm.showHighScores)?_c('PlayArea'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }